import React, { useContext, useEffect } from 'react'
import { UserContext } from './common/UserContext';
import { useNavigate } from 'react-router-dom';

function Home() {
    const {
      UM_GroupId,
      UM_CompanyGrpID,
      selectedScpId,
      UM_CompanyID,
      UM_UserId,
      UM_UserCode,
      UM_DefaultSCPId,
      UM_DisplayName
    } = useContext(UserContext);

    useEffect(() => {
      if (UM_GroupId != null) sessionStorage.setItem("UM_GroupId", UM_GroupId);
      if (UM_CompanyGrpID != null) sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
      if (UM_DefaultSCPId != null) sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
      if (UM_CompanyID != null) sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
      if (UM_UserId != null)   sessionStorage.setItem("UM_UserId", UM_UserId);
      if (UM_UserCode != null) sessionStorage.setItem("UM_UserCode", UM_UserCode);
      if (selectedScpId != null) sessionStorage.setItem("selectedScpId", selectedScpId);
      if (UM_DisplayName != null) sessionStorage.setItem("UM_DisplayName", UM_DisplayName);
    }, [
      UM_GroupId,
      UM_CompanyGrpID,
      UM_DefaultSCPId,
      UM_CompanyID,
      UM_UserId,
      UM_UserCode,
      selectedScpId,
      UM_DisplayName
    ]);
  const navigate = useNavigate();
    // 🚫 Disable browser back button on Home
useEffect(() => {
  const handleBack = () => {
    navigate(1); // push user forward
  };

  window.history.pushState(null, "", window.location.href);
  window.addEventListener("popstate", handleBack);

  return () => {
    window.removeEventListener("popstate", handleBack);
  };
}, []);


    return <div></div>;
}

export default Home;

